import { ThemeExposure } from '@api/api/theme-overview';
import { TableCell } from '@design/components/table';

import type { IndustryThemeTimeframe } from './useIndustryThemeMetrics';
import { useIndustryThemeMetrics } from './useIndustryThemeMetrics';
import type {
  IndustryThemeRowData,
  IndustryThemesTableColumn,
} from './useIndustryThemesColumns';

export interface IndustryThemeRowProps {
  themeExposure: ThemeExposure;
  timeframe: IndustryThemeTimeframe;
  columns: IndustryThemesTableColumn[];
}

export const IndustryThemeRow = ({
  themeExposure,
  timeframe,
  columns,
}: IndustryThemeRowProps) => {
  const metrics = useIndustryThemeMetrics(themeExposure.theme.id, timeframe);

  const row: IndustryThemeRowData = {
    themeId: themeExposure.theme.id,
    rank: themeExposure.relationship.rank,
    name: themeExposure.theme.name,
    logoUrl: themeExposure.theme.logo_url,
    reportedCount: metrics.reportedCount,
    totalCount: metrics.totalCount,
    epsStat: metrics.epsStat,
    revenueStat: metrics.revenueStat,
    guidanceStat: metrics.guidanceStat,
    medianT1: metrics.medianT1,
    medianT2: metrics.medianT2,
    leadingDriver: metrics.leadingDriver,
    isLoading: metrics.isLoading,
  };

  return (
    <tr>
      {columns.map(column => (
        <TableCell
          key={column.id}
          alignment={column.alignment ?? 'left'}
          isNumber={column.id === 'rank'}
          condensed
        >
          {column.cell(row)}
        </TableCell>
      ))}
    </tr>
  );
};
